import axios from "axios";

// Get catchup list for a specific label (category)
const getCatchupsByLabel = async (labelId, page = 0, size = 16, options) => {
  return await axios.get(`/client/label/${labelId}`, {
    ...options, params: { page: page, size: size }
  });
};

// Get catchup details by catchup ID
const getCatchupById = async (catchupId, options) => {
  return await axios.get(`/client/catchup/${catchupId}`, options);
};

// Watch catchup (for play URL) - only for movie and episode IDs
const watchCatchup = async (catchupId) => {
  return await axios.post(`/client/catchup/${catchupId}/watch`);
};

// Get episodes for a catchup season by season ID
const getCatchupEpisodesBySeason = async (seasonId, options) => {
  return await axios.get(`/client/catchup/${seasonId}`, options);
};

export {
  getCatchupsByLabel,
  getCatchupById,
  watchCatchup,
  getCatchupEpisodesBySeason
};